import { useBalanceStore } from "../store/balance.store";

interface UseBalanceReturn {
  balance: ReturnType<typeof useBalanceStore.getState>["balance"];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Хук для работы с балансом пользователя
 * Теперь использует Zustand store для глобального состояния
 */
export const useBalance = (): UseBalanceReturn => {
  const balance = useBalanceStore(state => state.balance);
  const loading = useBalanceStore(state => state.loading);
  const error = useBalanceStore(state => state.error);
  const fetchBalance = useBalanceStore(state => state.fetchBalance);

  return {
    balance,
    loading,
    error,
    refetch: fetchBalance
  };
};
